export default __webpack_public_path__ + "static/media/love.68ebedaa.png";